import cjk from 'cjk-regex'
import qs from 'qs'
import * as R from 'ramda'

import { getAuthHeader } from './userHelper'

export const getQuery = R.memoizeWith(
  R.identity as any,
  R.unless(R.isEmpty, (search) => qs.parse(search, { ignoreQueryPrefix: true }))
)

export const axiosGetAuthHeaderInterceptor = async (config: any) => {
  const authHeader = await getAuthHeader()
  return R.set(R.lensPath(['headers', 'Authorization']), authHeader, config)
}

export const axiosSetAllowCORSInterceptor = (config: any) =>
  R.set(R.lensPath(['headers', 'Access-Control-Allow-Origin']), '*', config)

export const convertDateTimeToString = (dateTime?: number) =>
  dateTime ? new Date(dateTime).toLocaleString() : ''

export const isURL = (str: string) =>
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(
    str
  )

export const truncateString = (str: string, size: number) =>
  str.length > size ? str.substring(0, size + 1) + '...' : str

const cjkLetters = cjk.letters().toRegExp()

const convertChar = R.unless(
  R.either(R.test(cjkLetters), R.test(/[a-zA-Z0-9]/)),
  R.always('-')
)

const cleanUpDuplicateDash = R.replace(/-+/g, '-')

const cleanUpLeadingTrailingDash = R.replace(/(^-|-$)/g, '')

export const slugify = R.pipe(
  R.split(''),
  R.map(convertChar),
  R.join(''),
  R.toLower,
  cleanUpDuplicateDash,
  cleanUpLeadingTrailingDash
)
